(ns ui.wallet.i18n.es
  "Spanish dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "cargando..."
   :page/command-failed "Algo salió mal. Inténtalo de nuevo o escríbenos por el chat si se repite."

   :balance/total-available "Saldo disponible"
   :balance/pay-as-you-go "Saldo de pago por uso"
   :balance/used-up "Añade crédito para seguir publicando."
   :balance/view-usage "Ver consumo"

   :payment/title "Pago"
   :payment/method "Método de pago"
   :payment/billing-email "Correo de facturación"
   :payment/reference "Referencia"
   :payment/update "Cambiar método de pago"
   :payment/card [:fn/str "Tarjeta ({{:last4}})"]
   :payment/wire-transfer "Transferencia bancaria"

   :billing-email/change "Cambiar"
   :billing-email/new "Nuevo email de facturación"
   :billing-email/save "Guardar"
   :billing-email/saving "Guardando..."
   :billing-email/cancel "Cancelar"
   :billing-email/hint "Paddle, nuestro revendedor, envía los recibos y las facturas a esta dirección."
   :billing-email/shared-hint "Si varias de tus organizaciones comparten esta cuenta de facturación, el cambio se aplica a todas."
   :billing-email/invalid "Introduce una dirección de email válida."
   :billing-email/taken "Esta dirección de email ya la usa otra cuenta de facturación. Usa otra dirección o escríbenos por el chat."

   :customer-conflict/title "Tu email ya está vinculado a otra cuenta"
   :customer-conflict/text "Tu dirección de email ya pertenece a la cuenta de facturación de otra organización de Storrito, y nuestro proveedor de pagos Paddle solo permite una cuenta de facturación por email. Escríbenos por el chat y lo solucionamos."
   :customer-conflict/chat "Abrir el chat de soporte"
   :customer-conflict/support-message "Hola, no puedo abrir el pago: mi dirección de email ya pertenece a otra cuenta de facturación."

   :top-up/title "Recarga automática"
   :top-up/custom-amount "Importe personalizado"
   :top-up/opening-checkout "Abriendo el pago..."
   :top-up/amount-missing "Introduce un importe."
   :top-up/amount-too-small [:fn/str "El mínimo es ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "El máximo es ${{:maximum}} por recarga. Para importes mayores, escríbenos por el chat."]
   :top-up/per-month [:fn/str "${{:quantity}} cada mes"]
   :top-up/per-year [:fn/str "${{:quantity}} cada año"]
   :top-up/stops-on [:fn/str "Termina el {{:date}}"]
   :top-up/next-on [:fn/str "Próxima recarga el {{:date}}"]
   :top-up/status-cancellation-scheduled "cancelación programada"
   :top-up/status-payment-failed "pago fallido"
   :top-up/status-active "activa"
   :top-up/past-due "No se pudo cobrar la última recarga. "
   :top-up/update-payment-method "Actualiza tu método de pago"
   :top-up/resume "Reanudar la recarga automática"
   :top-up/cancel "Cancelar la recarga automática"
   :top-up/paddle-unavailable "No hemos podido cargar los datos de tu recarga automática desde Paddle. Inténtalo de nuevo en un momento."
   :top-up/try-again "Reintentar"

   :plan/title-monthly "Recarga mensual"
   :plan/title-yearly "Recarga anual"
   :plan/switch "Cambiar a pago por uso"
   :plan/switching "Cambiando..."
   :plan/switch-confirm [:fn/str "Tu recarga recurrente de ${{:quantity}} termina ahora; el cambio es gratuito. Tu saldo y tu forma de pago se mantienen. A partir de entonces solo pagas cuando añades créditos, o automáticamente con la recarga automática."]
   :plan/wont-cover [:fn/str "Tu saldo probablemente no cubra tus cuentas de Instagram conectadas hasta la próxima recarga el {{:date}}; las historias dejan de publicarse al llegar a $0."]
   :plan/wont-cover-advice "Activa abajo la recarga automática o añade créditos ahora."

   :on-demand/add-credits "Añadir crédito"
   :on-demand/choose-amount "Elige un importe. Solo pagas por lo que usas."
   :on-demand/auto-top-up "Recarga automática"
   :on-demand/rule [:fn/str "Cuando tu saldo baje de ${{:threshold}}, añadimos ${{:amount}} automáticamente."]
   :on-demand/auto-top-up-hint "Opcional. Tus historias se siguen publicando cuando el saldo se agota; puedes desactivarlo cuando quieras."
   :on-demand/add [:fn/str "Añadir ${{:amount}}"]
   :on-demand/charged-once "Se cobra una sola vez ahora a través de Paddle, nuestro distribuidor. Tu tarjeta se guarda para futuras recargas, sin cargos recurrentes. El crédito no es reembolsable. Precios sin IVA."
   :on-demand/discount-off [:fn/str "{{:percent}} % de descuento en"]
   :on-demand/discount-applied "Se aplica a tu tarifa diaria a partir de tu primera recarga, no al importe que añades. El crédito de bienvenida se factura a la tarifa normal."
   :on-demand/charged-to-card "Se cobra a tu método de pago guardado y está disponible en segundos."
   :on-demand/confirm-charge [:fn/str "Se te cobrarán ahora ${{:amount}} USD sin impuestos."]
   :on-demand/charging "Cobrando..."
   :on-demand/add-now [:fn/str "Añadir ${{:amount}} ahora"]
   :on-demand/payment-accepted "Pago aceptado, tu saldo se actualiza en unos segundos."
   :on-demand/prices-excl-vat "Precios sin IVA."
   :on-demand/amount-too-large [:fn/str "El máximo es ${{:maximum}} por recarga."]
   :on-demand/on "Activada"
   :on-demand/off "Desactivada"
   :on-demand/saving "Guardando..."
   :on-demand/save "Guardar"
   :on-demand/custom-auto-top-up-amount "Importe personalizado de la recarga automática"
   :on-demand/one-charge-per-day "Como máximo un cargo automático al día, a tu método de pago guardado, más los impuestos aplicables."
   :on-demand/remove-payment-method "Eliminar método de pago"

   :transactions/title "Transacciones recientes"
   :transactions/full-statement "Extracto completo"
   :transactions/invoices "Facturas"
   :transactions/date "Fecha"
   :transactions/description "Descripción"
   :transactions/amount "Importe"
   :transactions/error "No se pudieron cargar las transacciones."
   :transactions/empty "Todavía no hay compras este mes."
   :transactions/welcome-credits "Crédito de bienvenida"
   :transactions/recurring-top-up "Recarga recurrente"
   :transactions/added-credits "Crédito añadido"
   :transactions/refund "Reembolso de crédito"

   :credit-notes/view "Notas de crédito"
   :credit-notes/title "Notas de crédito"
   :credit-notes/intro "Notas de crédito de tus reembolsos y créditos. Las emite Paddle, nuestro revendedor."
   :credit-notes/refund "Reembolso"
   :credit-notes/credit "Crédito"
   :credit-notes/download "Descargar PDF"
   :credit-notes/empty "Aún no hay notas de crédito."
   :credit-notes/error "No se pudieron cargar las notas de crédito."

   :offer/applied-automatically "Se aplica automáticamente al añadir créditos. Hasta entonces, el crédito de bienvenida se factura a la tarifa normal."

   :rates/view "Ver nuestras tarifas"
   :rates/title "Nuestras tarifas de un vistazo"
   :rates/intro "Esto es lo que cobramos por cada servicio. "
   :rates/intro-bold "Todos los precios en dólares estadounidenses sin impuestos (sin IVA)."
   :rates/per-day "por día"
   :rates/per-post "por publicación"
   :rates/per-image "por imagen"
   :rates/per-days [:fn/str "por {{:days}} días"]
   :rates/excl-vat "Todos los precios sin IVA"
   :rates/off [:fn/str "{{:percent}}% DTO."]

   :service.storage-flat-fee/name "Tarifa fija de almacenamiento"
   :service.storage-flat-fee/description "para todas tus imágenes, vídeos, etc."
   :service.instagram-connection/name "Conexión de cuenta de Instagram"
   :service.instagram-connection/description "Historias y Reels ilimitados para un nombre de usuario de Instagram."
   :service.tiktok-post/name "Publicación en TikTok"
   :service.tiktok-post/description "Publica un vídeo o una imagen en TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Publica un vídeo renderizado como YouTube Short."
   :service.social-post/name "Publicación social"
   :service.social-post/description "Publica un vídeo renderizado o una imagen en Facebook, Threads y otras plataformas conectadas (X se factura aparte)."
   :service.x-post/name "Publicación en X"
   :service.x-post/description "Publica un vídeo renderizado en X. X cobra cada publicación hecha a través de su API, por eso las publicaciones en X cuestan más que otras publicaciones sociales."
   :service.x-post-link/name "Publicación en X con enlace"
   :service.x-post-link/description "Una publicación en X cuyo texto contiene un enlace. X cobra mucho más por las publicaciones con enlaces."
   :service.ai-image/name "Imagen con IA"
   :service.ai-image/description "Generación de una imagen con IA (Dall-e / Blackforest)."})
